import React, { useEffect } from "react";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { BarcodeProvider } from "./context/BarcodeContext";
import { PurchaseItemsProvider } from "./context/PurchaseItemsContext";
import { ChatUnreadProvider } from "./context/ChatUnreadContext";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./components/AlertModal";
import AppRoutes from "./AppRoutes"; 
import { setNavigateFunction } from "./utils/api";

const RouterWrapper = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    setNavigateFunction(navigate);
  }, [navigate]);

  return <AppRoutes />;
};

const App = () => {
  return (
    <AlertProvider>
      <AuthProvider>
        <ChatUnreadProvider>
          <PurchaseItemsProvider>
            <BarcodeProvider>
              <Router>
                <AppRoutes />
              </Router>
            </BarcodeProvider>
          </PurchaseItemsProvider>
        </ChatUnreadProvider>
      </AuthProvider>
    </AlertProvider>
  );
};

export default App;
